/** @jsx jsx */

import React from 'react';
import Helmet from 'react-helmet';
import { ThemeProvider } from 'emotion-theming';
import { jsx } from 'theme-ui';
import Theme from '../gatsby-plugin-theme-ui/index';

import Navbar from './navbar/navbar';
import Footer from './footer/footer';
import MobileNavbar from './mobile-navbar/mobile-navbar';
// @ts-ignore
import favicon from '../assets/logos/favicon.png';

import './layout.scss';

import '../global.scss';

const Layout = ({ children }: any) => {
  return (
    <ThemeProvider theme={Theme}>
      <Helmet></Helmet>
      <Navbar />
      <MobileNavbar />
      {children}
      <Footer />
  </ThemeProvider>
)};

export default Layout;
